/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type useListingStructuredData_listing$ref = any;
export type CompositePropertyType = "APPT" | "BUILDING" | "COMMERCIAL" | "GASTRO" | "HOUSE" | "HOUSE_APPT" | "OTHER" | "PARK" | "PROP" | "ROOM";
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingCard_listing$ref: FragmentReference;
declare export opaque type AggregatesListingCard_listing$fragmentType: AggregatesListingCard_listing$ref;
export type AggregatesListingCard_listing = {|
  +id: string,
  +slug: string,
  +encodedId: string,
  +offerType: OfferType,
  +shortDescription: ?string,
  +shortTranslatedDescription: ?string,
  +bulletPoints: ?$ReadOnlyArray<?string>,
  +propertyType: ?string,
  +numberOfRooms: ?number,
  +livingSurface: ?number,
  +isFavourite: boolean,
  +usableSurface: ?number,
  +landSurface: ?number,
  +salePrice: ?number,
  +grossRentMonthly: ?number,
  +grossRentM2yearly: ?number,
  +currency: ?string,
  +postcode: ?string,
  +subLocality: ?string,
  +route: ?string,
  +streetNumber: ?string,
  +images: $ReadOnlyArray<{|
    +bucketName: string,
    +fileName: string,
    +blurhash: ?string,
  |}>,
  +url: ?{|
    +url: string,
    +originalDomain: string,
    +originalUrl: string,
    +mergedListingId: string,
  |},
  +translatedTitle: ?string,
  +salePricePerLivingSurface: ?number,
  +salePricePerLandSurface: ?number,
  +createdAt: string,
  +propertyMainType: ?string,
  +compositePropertyType: CompositePropertyType,
  +visitContactPerson: ?string,
  +agencyName: ?string,
  +agencyReference: ?string,
  +lotReference: ?string,
  +constructionYear: ?number,
  +locality: ?string,
  +stateObject: ?{|
    +label: string
  |},
  +municipalityObject: ?{|
    +label: string
  |},
  +lat: ?number,
  +lng: ?number,
  +address: ?string,
  +numberOfBathrooms: ?number,
  +showDetailPage: boolean,
  +$fragmentRefs: useListingStructuredData_listing$ref,
  +$refType: AggregatesListingCard_listing$ref,
|};
export type AggregatesListingCard_listing$data = AggregatesListingCard_listing;
export type AggregatesListingCard_listing$key = {
  +$data?: AggregatesListingCard_listing$data,
  +$fragmentRefs: AggregatesListingCard_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "sentences",
    "value": 3
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingCard_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "encodedId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    },
    {
      "alias": "shortDescription",
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "description",
      "storageKey": "description(sentences:3)"
    },
    {
      "alias": "shortTranslatedDescription",
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "translatedDescription",
      "storageKey": "translatedDescription(sentences:3)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulletPoints",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfRooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "livingSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFavourite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usableSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grossRentMonthly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grossRentM2yearly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postcode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subLocality",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "route",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "streetNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "AggregatesListingImage",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bucketName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blurhash",
          "storageKey": null
        }
      ],
      "storageKey": "images(first:100)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        }
      ],
      "concreteType": "ExternalUrl",
      "kind": "LinkedField",
      "name": "url",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalDomain",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mergedListingId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "translatedTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePricePerLivingSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePricePerLandSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyMainType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compositePropertyType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitContactPerson",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agencyReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lotReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "constructionYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "locality",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "stateObject",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Place",
      "kind": "LinkedField",
      "name": "municipalityObject",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfBathrooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showDetailPage",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useListingStructuredData_listing"
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '66a1b0019ce1166c58f9ec2a6ac28d2a';

export default node;
